import axios from 'axios';
import vopayApi from '@/services/api.config';
import { SubAccount, SubAccountsRequest, CreateSubAccountRequest, AccountTransferToRequest } from 'vopay';
import { useState } from 'react';

const { api } = vopayApi;

export default function useSubAccounts() {
  const source = axios.CancelToken.source();
  const [subAccounts, setSubAccounts] = useState<SubAccount[]>([]);

  async function fetchSubAccounts(params: SubAccountsRequest) {
    try {
      const res = await api.fetchSubAccounts(params, source);
      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }
      setSubAccounts(Object.values(res.Subaccounts));
      return res;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  async function createSubAccount(params: CreateSubAccountRequest) {
    try {
      const res = await api.createSubAccount(params, source);
      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }
      return res;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  // `bearer` runs the transfer as a sub-account instead of the logged-in user.
  async function transferAccountTo(params: AccountTransferToRequest, bearer?: string) {
    try {
      const res = await api.postAccountTransferTo(params, source, bearer);
      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }
      return res;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  return {
    subAccounts,
    fetchSubAccounts,
    createSubAccount,
    transferAccountTo,
  };
}
